import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "kl-sector-list",
  templateUrl: "./sector-list.component.html",
  styleUrls: ["./sector-list.component.scss"],
})
export class SectorListComponent implements OnInit {
  @Input() mode;
  @Input() tabId: string;
  @Input() modalId: string;

  filterSelectItems = [
    {
      name: "code",
      description: "code",
    },
    {
      name: "description",
      description: "description",
    },
  ];

  constructor() {}

  ngOnInit() {}
}
